import ApiService from '@/services/api.service'

const ChargeSheet = {

    getAll(parameter){
           const requestData = {
               method: 'get',
               url: "/ChargeSheet/",
               params: {
                 SearchCriteria: parameter.SearchCriteria,
                 PageSize: parameter.PageSize,
                 PageNumber: parameter.PageNumber,
                 DateFrom: parameter.DateFrom,
                 DateTo: parameter.DateTo,
                 Status: parameter.Status,
                 ProgramCode: parameter.ProgramCode,
                 PatientCode: parameter.PatientCode,
                 RecordId: parameter.RecordId,
               }
             }
             return ApiService.customRequest(requestData);
       },

    getChargeSheetPatientInfo(parameter){
           const requestData = {
               method: 'get',
               url: "/ChargeSheet/PatientInfo",
               params: {
                 AdmissionRecordID: parameter.AdmissionRecordID,
               }
             }
            return ApiService.customRequest(requestData);
    },

    getChargeSheetSummary(parameter){
           const requestData = {
               method: 'get',
               url: "/ChargeSheet/Summary",
               params: {
                 PageSize: parameter.PageSize,
                 PageNumber: parameter.PageNumber,
                 AdmissionRecordID: parameter.AdmissionRecordID,
               }
             }
            return ApiService.customRequest(requestData);
    },

    getChargeSheetActions(parameter){
           const requestData = {
               method: 'get',
               url: "/ChargeSheet/Actions",
               params: {
                 PageSize: parameter.PageSize,
                 PageNumber: parameter.PageNumber,
                 PatientCode: parameter.PatientCode,
                 AdmissionGroupCreationId: parameter.AdmissionGroupCreationId,
                 AdmissionDateFrom: parameter.AdmissionDateFrom,
                 AdmissionDateTo: parameter.AdmissionDateTo,
               }
             }
            return ApiService.customRequest(requestData);
    },

    getChargeSheetDetail(parameter){
           const requestData = {
               method: 'get',
               url: "/ChargeSheet/Detail",
               params: {
                 PageSize: parameter.PageSize,
                 PageNumber: parameter.PageNumber,
                 AdmissionRecordID: parameter.AdmissionRecordID,
                 ServiceDateFrom: parameter.ServiceDateFrom,
                 ServiceDateTo: parameter.ServiceDateTo,
               }
             }
            return ApiService.customRequest(requestData);
    },

    ResetRoomCharge(RecordID){
        return ApiService.delete(`/ChargeSheet/${RecordID}`);
    },

    getChargeSheetICD9Procedures(){
           const requestData = {
               method: 'get',
               url: "/ChargeSheet/ICD9Procedures",
            }
            return ApiService.customRequest(requestData);
    },

    getChargeSheetGetICD9(Code){
        return ApiService.get(`/ChargeSheet/GetICD9/${Code}`);
    },

    ChargeSheetIsIDC9(PatientCode){
        return ApiService.get(`/ChargeSheet/IsICD9/${PatientCode}`);
    },

    getChargeSheetReadICD10Codes(parameter){
           const requestData = {
               method: 'get',
               url: "/ChargeSheet/ReadICD10Codes",
               params: {
                 PatientCode: parameter.PatientCode,
                 RecordID: parameter.RecordID,
               }
             }
            return ApiService.customRequest(requestData);
    },

    getConditionByCode(Version,Id){
        return ApiService.get(`/ChargeSheet/OtherDiagnosis?Version=${Version}&Id=${Id}`);
    },

    getDoctorByCode(Code){
        return ApiService.get(`/Doctors/${Code}`);
    },

    AddICD10(PatientCode, RecordId, data){
        return ApiService.put(`/ChargeSheet/AddICD10/${PatientCode}/${RecordId}`,data);
    },

    GetAddtInfo(PatientCode,RecordId){
        return ApiService.get(`/ChargeSheet/AddtInfo/${PatientCode}/${RecordId}`);
    },

    UpdateDiagnosis(PatientCode, data){
        return ApiService.put(`/Patients/ChargeSheetUpdate/${PatientCode}`,data);
    },

    UpdateAllClaim(data){
        return ApiService.put(`/PatientClaims/ChargeSheetUpdate`,data);
    },

    GetPriceInfoData(RecordId){
        return ApiService.get(`/ChargeSheet/PriceInfo/${RecordId}`);
    },

    GetDownloadPriceInfo(RecordId){
        return ApiService.get(`/ChargeSheet/DownloadPriceInfo/${RecordId}`);
    },

    GetCompute(RecordId,PatientCode,Occurences){
        return ApiService.get(`/ChargeSheet/Compute/${PatientCode}/${RecordId}/${Occurences}`);
    },

}

export default ChargeSheet;
